<script setup lang="ts">
const paginationContext = usePaginationContext();
const theme = usePaginationTheme();

defineProps<{
  ariaLabel?: string;
}>();

function isActivePage(page: (typeof paginationContext.displayPages.value)[number]) {
  return page.number === paginationContext.currentPage.value;
}
</script>

<template>
  <li
    v-for="page in paginationContext.displayPages.value"
    :key="page.key"
    :class="theme.item()"
  >
    <PaginationButton
      :disabled="page.disabled"
      :aria-label="ariaLabel ?? $t('Pagination.Aria.PageButton', { page: page.number })"
      :aria-current="isActivePage(page) ? 'page' : undefined"
      :active="isActivePage(page)"
      :on-click="() => paginationContext.goToPage(page.number)"
    >
      {{ page.label }}
    </PaginationButton>
  </li>
</template>
